import {cn} from 'platform/shared-tw';

import {PartSvg, type PartMode} from '../shared/PartSvg';
import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface CenterConsoleProps {
  readonly mode?: PartMode;
  readonly variant?: DiagramVariant;
  readonly onClick?: () => void;
}

export function CenterConsole(props: CenterConsoleProps) {
  return (
    <PartSvg
      mode={props.mode}
      onClick={props.onClick}
      label="Center Console"
      width={232}
      height={70}
      viewBox="0 0 232 70"
      position={{top: 216, left: 510}}
    >
      <path
        d="M1.00013 57.0001L1.00013 35.0001L1.00016 13C1.00016 8.00003 0.902793 7.91281 6.00016 5.00003C13.0002 1.00003 13.0002 1.00003 16.0002 1.00003L53.0002 1.00004C70.0002 1.00004 90.0002 9.00003 90.0002 9.00003L90.0001 61.0001C90.0001 61.0001 70.0001 69.0001 53.0001 69.0001L16.0001 69.0001C13.0001 69.0001 13.0001 69.0001 6.00013 65.0001C0.902762 62.0873 1.00013 62.0001 1.00013 57.0001Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <rect
        x="18"
        y="10"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="24"
        y="10"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="30"
        y="10"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="18"
        y="52"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="24"
        y="52"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="30"
        y="52"
        width="3"
        height="8"
        rx="1.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="55"
        y="30"
        width="3"
        height="10"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M60 53H46C44.8954 53 44 52.1046 44 51V19C44 17.8954 44.8954 17 46 17H60C61.1046 17 62 17.8954 62 19V35V51C62 52.1046 61.1046 53 60 53Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M76 55C69 61 52 65 41 65H16C16 65 13 65 13 62V35V8C13 5 16 5 16 5H41C52 5 69 9 76 15"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path d="M38 5V65" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path d="M13 23H38" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path d="M13 47H38" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path
        d="M1.00013 57.0001L1.00013 35.0001L1.00016 13C1.00016 8 0.902793 7.91278 6.00016 5C13.0002 0.999999 13.0002 0.999999 16.0002 0.999999L53.0002 1.00001C70.0002 1 90.0002 9 90.0002 9L90.0001 61.0001C90.0001 61.0001 70.0001 69.0001 53.0001 69.0001L16.0001 69.0001C13.0001 69.0001 13.0001 69.0001 6.00013 65.0001C0.902762 62.0873 1.00013 62.0001 1.00013 57.0001Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M16 43C20.8 43 29 41.5 29 39V38H32C32.5523 38 33 37.5523 33 37V33C33 32.4477 32.5523 32 32 32H29V31C29 28.5 20.8 27 16 27C11.2 27 10 29 10 30V40C10 41 11.2 43 16 43Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M29 32H32C32.5523 32 33 32.4477 33 33V37C33 37.5523 32.5523 38 32 38H29V32Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M10 40V35V30C10 29 11.2 27 16 27C20.8 27 29 28.5 29 31V35V39C29 41.5 20.8 43 16 43C11.2 43 10 41 10 40Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M10 30.0001C13 30 23 30 29 33"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M10 39.9999C13 40 23 40 29 36.9999"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M68 42V35V28C68 21.0001 76 7 104 7H219C230 7 231 9 231 17.9999V35V52.0001C231 61 230 63 219 63H104C76 63 68 48.9999 68 42Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M68 42V35V28C68 21.0001 76 7 104 7H219C230 7 231 9 231 17.9999V35V52.0001C231 61 230 63 219 63H104C76 63 68 48.9999 68 42Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M186 7V63"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M224 45L224 35L224 25C224 19 223 16 214 16L186 16.0001V25.0001L186 34.9999V54L205 53.9999L214 54C223 54 224 51 224 45Z"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path d="M215 16V54" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path d="M218 16V54" stroke="currentColor" className={partStroke({variant: props.variant})} />
      <path
        d="M221 17L221 53"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M212 35H224"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="224"
        y="23"
        width="7"
        height="24"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <rect
        x="191"
        y="21"
        width="16"
        height="28"
        rx="2"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M212 16V54"
        stroke="currentColor"
        strokeWidth="2"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M224 35H231"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M224 31H231"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M224 27H231"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M224 43H231"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M224 39H231"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </PartSvg>
  );
}
